export default __webpack_public_path__ + "static/media/error_outline.82dbef12.svg";